import React from 'react';

import Button from 'CommonComponents/Button';

import FilterIcon from 'Assets/icons/filter.svg';

// Milestones exist, but the filters, Key milestones only or the Period leave none to show.
const RoadmapFilteredEmptyState = ({ onReset }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-6 tw-py-16 tw-border tw-border-charcoal-25 tw-rounded-lg">
        <div className="tw-flex tw-items-center tw-justify-center tw-h-14 tw-w-14 tw-rounded-full tw-bg-background tw-mb-4">
            <FilterIcon className="tw-h-6 tw-w-6 tw-text-charcoal-50" aria-hidden="true" />
        </div>
        <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-1">{$t('No milestones match the current filters or period')}</h4>
        <p className="tw-text-sm tw-text-charcoal-75 tw-max-w-sm tw-mb-4">
            {$t('Clear the filters, turn off Key milestones only or set the Period back to All dates.')}
        </p>
        <Button variant="secondary" small onClick={onReset}>
            {$t('Reset filters')}
        </Button>
    </div>
);

export default RoadmapFilteredEmptyState;
